import { get } from 'lodash';

const styles = (theme) => ({
  dropIcon: {
    color: get(theme, 'color.grey'),
    marginLeft: 2,
    marginTop: -6,
    marginBottom: 0,
    height: "35px",
    width: "35px",
    cursor: "pointer",
  },
  dropIconContainer: {
    display: 'flex',
  },
  fieldContainer: {
    marginTop: "0 !important",
    width: "200px !important",
  },
  fieldObjectContainer: {
    marginLeft: "6px !important",
    width: "200px !important",
  },
  dateRangeContainerClass: {
    marginLeft: "6px !important",
    width: "440px !important",
  },
  clearAllButton: {
    margin: "6px !important",
    color: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
  },
  auditSettingsTitle: {
    position: "absolute",
    top: "5.5rem",
    left: "4.7rem",
    fontWeight: "bold",
    color: get(theme, 'typography.bodyText'),
  },
  flexWrap: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
})

export default styles;
